import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import SEO from "@/components/SEO";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background text-foreground overflow-hidden">
      <SEO
        title="404 — Page Not Found | Padmora"
        description="The page you're looking for doesn't exist. Return to Padmora's homepage for AI-powered commodity trading solutions, LC-backed deals, and compliance automation."
        noindex={true}
        canonical={`https://padmora.com${location.pathname}`}
        keywords={[
          "404 error",
          "page not found",
          "Padmora homepage",
          "commodity trading",
          "US trading firm",
          "AI trading platform"
        ]}
        structuredData={{
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "404 - Page Not Found",
          "description": "Error page for non-existent URLs on Padmora website",
          "mainEntity": {
            "@type": "SiteNavigationElement",
            "name": "Homepage Redirect",
            "url": "https://padmora.com"
          },
          "publisher": {
            "@type": "Organization",
            "name": "Padmora",
            "url": "https://padmora.com"
          }
        }}
        customMeta={[
          { name: "robots", content: "noindex, nofollow, noarchive" },
          { name: "googlebot", content: "noindex, nofollow, noarchive" }
        ]}
      />
      <div className="text-center p-8 space-y-6 relative">
        <div
          className="absolute -top-20 -left-20 w-48 h-48 rounded-full mix-blend-lighten filter blur-xl opacity-70 animate-blob"
          style={{ backgroundColor: "hsl(var(--primary) / 0.5)" }}
        ></div>
        <div
          className="absolute -bottom-20 -right-10 w-48 h-48 rounded-full mix-blend-lighten filter blur-xl opacity-70 animate-blob animation-delay-2000"
          style={{ backgroundColor: "hsl(var(--secondary) / 0.5)" }}
        ></div>
        <div
          className="absolute -bottom-20 -left-10 w-48 h-48 rounded-full mix-blend-lighten filter blur-xl opacity-70 animate-blob animation-delay-4000"
          style={{ backgroundColor: "hsl(var(--primary) / 0.3)" }}
        ></div>

        <h1
          className="text-8xl md:text-9xl font-bold z-10"
          style={{ color: "hsl(var(--primary))" }}
        >
          404
        </h1>
        <div className="z-10">
          <h2 className="text-2xl md:text-4xl font-semibold mb-2">
            Houston, we have a problem.
          </h2>
          <p className="text-lg md:text-xl" style={{ color: "hsl(var(--muted-foreground))" }}>
            It seems you've wandered into the cosmic void.
          </p>
          <p className="mt-2" style={{ color: "hsl(var(--muted-foreground))" }}>
            The page you're looking for at{" "}
            <code
              className="p-1 rounded"
              style={{
                backgroundColor: "hsl(var(--muted))",
                color: "hsl(var(--primary))",
              }}
            >
              {location.pathname}
            </code>{" "}
            is lost in space.
          </p>
        </div>

        <div className="text-6xl animate-pulse z-10">🚀</div>

        <a
          href="/"
          className="relative inline-block px-6 py-3 font-semibold rounded-lg shadow-lg transition-colors duration-300 z-10"
          style={{
            backgroundColor: "hsl(var(--primary))",
            color: "hsl(var(--primary-foreground))",
          }}
        >
          Return to Mission Control
        </a>
      </div>
    </div>
  );
};

export default NotFound;
